import api from "../services/api";
import { APIS } from "../endpoints";

export const getMasterlistSubTypesAPI = async (searchTerm) => {
  const result = await api.get(`${APIS.BASE_URL}${APIS.masterlistSubTypes}?search=${searchTerm}`);
  if (result) {
    return result?.data;
  }
};

export const fetchMasterlistSubTypes = async (inputValue) => {
  try {
    const result = await getMasterlistSubTypesAPI(inputValue);
    if (result?.data && Array.isArray(result?.data)) {
      return result?.data?.map((item) => ({
        label: item?.masterlist_sub_type,
        value: item?.masterlist_sub_type,
      }));
    }
    return [];
  } catch (error) {
    console.error('Error fetching masterlist subtypes:', error);
    return [];
  }
};
